"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doubleOptInSubscr;
exports.doubleOptInConfirm = doubleOptInConfirm;
exports.doubleOptInUnsub = doubleOptInUnsub;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
// eslint-disable-next-line import/no-unresolved

function doubleOptInSubscr(payload) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/communication/v0/public/advertisement"), payload, {}, false, false);
}
function doubleOptInConfirm(payload) {
  return _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/communication/v0/public/advertisement?").concat(new URLSearchParams(Object.entries(payload)).toString()), null, {}, false, false);
}
function doubleOptInUnsub(payload) {
  return _RestHelper.default.delete("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/communication/v0/public/advertisement"), payload, {}, false, false);
}